import { render, staticRenderFns } from "./QAdInsertionDataTable.vue?vue&type=template&id=8b4ce9f0&scoped=true&"
import script from "./QAdInsertionDataTable.vue?vue&type=script&lang=js&"
export * from "./QAdInsertionDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QAdInsertionDataTable.vue?vue&type=style&index=0&id=8b4ce9f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ce9f0",
  null
  
)

export default component.exports